module.exports = __webpack_public_path__ + "img/serve1.42da126f.png";